export function ncEightDLocation(input, article, caseId, back) {
    return {
        name: caseId ? "qualita-8d-interna" : "qualita-8d-cliente",
        params: caseId ? {caseId} : {articolo: article, numero: input.numero, riga: String(input.riga)},
        query: {back},
    };
}

export function ncEightDBack(value, internal) {
    return typeof value === "string" && value.startsWith("/") && !value.startsWith("//") && !value.startsWith("/qualita/8d/")
        ? value : internal ? "/qualita/nc-interne/" : "/qualita/riepologonc/";
}
